const liquidationHeight = {
  BORDEREAU: 60,
  MOUVEMENT_REDUCE: 100,
  MOUVEMENT_EXPANDED: 500,
  CREATE_MOUVEMENT: 61,
  DEFAULT: 50,
} as const;

export default liquidationHeight;
